import { render, staticRenderFns } from "./takeCoupon.vue?vue&type=template&id=2931d993&scoped=true&"
import script from "./takeCoupon.vue?vue&type=script&lang=js&"
export * from "./takeCoupon.vue?vue&type=script&lang=js&"
import style0 from "./takeCoupon.vue?vue&type=style&index=0&id=2931d993&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931d993",
  null
  
)

export default component.exports